export default{
	projectSn:'项目SN号',
	projectName:'项目名称',
	projectAddress:'项目地点',
	productType:'产品类型',
	batteryType:'电池类型',
	ownersInfo:'业主信息',
	commissioningTime:'投运时间',
	num:'数量',
	technicalTransformationNum:'技改次数',
	supplierInformation:'供应商信息',
	personnel:'人员',
	operation:'操作',
	statisticsInfo:'统计信息',
	projectList:'项目列表',
	add:'新增',
	productTypeStatistics:'产品类型数量统计',
	projectTop5:'项目技改次数统计TOP5',
	personnelProjectStatistics:'运维人员项目统计',
	projectInfo:'项目信息',
	addSupplier:'添加',
	subassembliesType:'子部件类型',
	suppliersName:'供应商名称',
	delete:'删除',
	userDetail:'人员详情',
	role:'人员角色',
	userName:'人员名称',
	confirm:'确定',
	cancle:'取消',
	deleteAlert:'确定要删除本条项目信息吗?',
	detail:'详情',
	supplierDetail:'供应商详情',
	noData:'暂无数据',
	technicalDetail:'项目技改详情',
	technicalTransformationDetail:'技术改造详情',
	technicalPlaceholder:'请输入本次技术改造详情',
	back:'返回',
	success:'成功',
	projectsuccess:'添加项目成功',
	editProjectSuccess:'编辑项目成功',
	deleteProjectSuccess:'删除项目成功',
	placeholderSN:'请输入项目SN号',
	placeholderName:'请输入项目名称',
	placeholderAddress:'请输入项目地点',
	placeholderOwner:'请输入业主信息'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/projectFiles.js